import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Router from "./config/RouterConfig";
import { initialAppOptions } from "./store/AuthSlice";
import PageSpinner from "./components/PageSpinner/PageSpinner";
import { handleStorageEvents } from "./config/Global";
import { useAppDispatch, useAppSelector } from "./utils/hooks/hooks";
import { loadMapApi } from "./components/Map/loadMapApi";

function App() {
  const dispatch = useAppDispatch();
  const appLoading = useAppSelector(state => state.auth.appLoading);

  useEffect(() => {
    dispatch(initialAppOptions()).catch((error: any) => error);
    window.addEventListener("storage", handleStorageEvents);
  }, [dispatch]);

  useEffect(() => {
    loadMapApi();
  }, []);
  return (
    <BrowserRouter>{appLoading ? <PageSpinner /> : <Router />}</BrowserRouter>

  )
}

export default App
